import React, { useState, useEffect, use } from "react";

// Components
import { List, Avatar, Flex, message, Tag, Space } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { CustomButton, CustomModal, ManufacturerSearch, CustomModalWithoutButton, CustomParagraph } from "../../../components";
import StepsHeading from "./StepsHeading";
import ConnectsSensors from "../../Modals/ConnectsSensors";
import { useSpin } from '../../../components/SpinContext';
import LinkIcon from "../../../assets/images/link-icon.svg";
import { GetSensors, LinkSensorsAccount,DeleteSensor } from "../../../api's/onboarding";
import useToken from '../../../common/helper/usetoken';
import { useNavigate } from "react-router-dom";
import { CloseOutlined, ClockCircleOutlined, } from '@ant-design/icons';
import AvatarIcon from '../../../assets/images/default icon.png'
import { getProviderImagePath } from '../../../common/utils/imageUtils';
import ZLShield from '../../../assets/images/ZLshield.png';
import Arrows from '../../../assets/images/arrows.png';

const Sensors = ({ onNext }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalName, setModalName] = useState("");
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("")
  const [list, setList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sensor_id, setSensorsId] = useState(null);
  const [sensorData, setSensorsData] = useState(null);
  const [showIntegrationMessageIndex, SetShowIntegrationMessageIndex] = useState(-1);

  const handleSuccess = () => {
    fetchData();
    setModalOpen(false);
    setSensorsId(null);
  };

  //get Listing call
  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = () => {
    showSpin();
    GetSensors(token)
      .then((res) => {
        if (res) {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              setList(data?.data?.data.length > 0 ? data?.data?.data : []);
              setFilteredData(data?.data?.data.length > 0 ? data?.data?.data : []);
            } else {
              message.error(data?.data?.message);
            }
          }
        }
      })
      .catch((err) => {
        unauthorize(err)
      })
      .finally(() => {
        hideSpin();
      });
  };


  const handleButtonClick = (item) => {
    if (item) {
      setSensorsId(item.id);
      setSensorsData(item);
      setModalName(item?.name ? item.name : "");
    }
    setModalOpen(true);
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  }

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchText(searchValue);

    if (searchValue.trim() === "") {
      setFilteredData(list);
    } else {
      const filteredItems = list.filter((item) =>
        item.name.toLowerCase().includes(searchValue)
      );
      setFilteredData(filteredItems);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSensorsId(null);
    setSensorsData(null);
  }

  const handleListMessage = (item) => {
    setFilteredData((prevList) =>
      prevList.map((ele) =>
        ele.id === item.id ? { ...ele, isIntegratedMessage: true } : ele
      )
    );
  };


    const handleDelete = (item) => {
          if (item && item?.company_sensor?.id) {
              showSpin();
              DeleteSensor(item?.company_sensor?.id, token)
                  .then((res) => {
            
                       const data = res?.data || null;
                      if (data) {
                          if (data?.data?.is_success) {
                              message.success(data?.data?.message)
                              fetchData();
                          } else {
                              message.error(data?.data?.message);
                          }
                      }
                  })
                  .catch((error) => {
                      unauthorize(error);
                  }).finally(() => {
                      hideSpin();
                  });
          }
      }


  return (
    <>
      <div className="default-steps-content">
        <StepsHeading
          heading="Connect your sensors"
          text="Connect your sensors so we can help you monitor the conditions of your shipments."
        />

        <ManufacturerSearch
          placeholder="Search for sensor..."
          width="420px"
          borderRadius="50px"
          height="36px"
          bgColor="#E6E6E6"
          value={searchText}
          search={handleSearch}
        />

        <List
          className="custom-list-container"
          itemLayout="horizontal"
          dataSource={filteredData}
          renderItem={(item, index) => {
            const imagePath = getProviderImagePath(item.name, 'SensorImages');
            return (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={<img src={imagePath} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "contain" }} />} />}
                title={
                  <>
                    <Space style={{ display: "flex" }}>
                      <CustomParagraph fontSize={14} fontWeight={500} color="#000" text={item.name} marginBottom={0} />
                      {item.is_enabled && (item.status === "Connected") && (
                        <Tag color="success" icon={<CheckOutlined style={{ color: "#0E8345" }} />}>
                          Synced
                        </Tag>
                      )}
                    </Space>
                  </>}
              />


              {item.is_enabled && (
                ((item.status === "Connected" && item.is_enabled)) ? (
                  <CloseOutlined style={{ color: "#5E5E5E" }} onClick={()=>handleDelete(item)}/>
                ) : ((item.is_enabled) ?
                  <CustomButton
                    onClick={() => handleButtonClick(item)}
                    height="36px"
                    fontSize="14px"
                    text="Link account"
                    bgColor="#E6E6E6"
                    borderRadius="8px"
                    color="#000"
                    boxShadow="none"
                    iconPosition="left"
                    image={LinkIcon}
                    gap="10px"
                    fontWeight={500}
                  /> : null)
              )}




              {!item.is_enabled && (
                <Flex align="center" justify="center">
                  {item.isIntegratedMessage ?
                    <p style={{ color: "#5E5E5E", fontSize: 12, whiteSpace: "nowrap", marginBottom: 0, marginRight: "10px" }}>A ZoomLogi representative will reach out to you to complete integration</p>
                    :
                    <CustomButton
                      onClick={() => handleListMessage(item)}
                      height="36px"
                      fontSize="14px"
                      text="Link account"
                      bgColor="#E6E6E6"
                      borderRadius="8px"
                      color="#000"
                      boxShadow="none"
                      iconPosition="left"
                      image={LinkIcon}
                      gap="10px"
                      fontWeight={500}
                    />
                  }
                </Flex>
              )}






              {/* {item.is_enabled && (
              ((item.status === "Connected" && !item.is_public &&  !item?.is_zoom_logi_provider) || item.is_public || item?.is_zoom_logi_provider) 
                <Flex align="center" justify="center" gap={8} style={{ fontWeight: 500 }}>
                  <CheckOutlined style={{ color: "#009951" }} />
                  Connected
                </Flex>
              ) )}
               */}

              {/* : (!item.is_enabled ? 
                <Flex align="center" justify="center">
                    <p style={{ color: "#5E5E5E", fontSize: 12, whiteSpace: "nowrap", position: "absolute", right: "48px", marginBottom: 0 }}>
                      A ZoomLogi representative will reach out to you to complete integration
                    </p>
                    {/* <Flex align="center" justify="center" style={{ width: 48, height: 48, cursor: "pointer" }}>
                      <CloseOutlined style={{ color: "#5E5E5E" }} />
                    </Flex> */}
              {/* </Flex> 
                   
                 :
                (item.is_enabled && !item.is_public && !item.is_zoom_logi_provider ? 
                <CustomButton
                  onClick={() => handleButtonClick(item)}
                  height="36px"
                  fontSize="14px"
                  text="Link account"
                  bgColor="#E6E6E6"
                  borderRadius="8px"
                  color="#000"
                  boxShadow="none"
                  iconPosition="left"
                  image={LinkIcon}
                  gap="10px"
                  fontWeight={500}
                /> : null)
              )} */}
            </List.Item>
            );
          }}
        />
        {modalOpen && sensorData && (
          <CustomModalWithoutButton
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            modalTitle={`Connect to ${modalName}`}
            modalText="By Providing API access to ZoomLogi, you're enabling ZoomLogi to retrieve your sensor information."
            modalSize={880}
            modalBorderRadius={"16px"}
            headerIcon={
              <Flex align="center" justify="center" gap={12}>
                <Avatar
                  src={<img src={getProviderImagePath(sensorData.name, 'SensorImages')} alt={sensorData.name} style={{ width: '100%', objectFit: 'contain' }} />}
                  size={52}
                  style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%'
                  }}
                />
                <img src={Arrows} alt="connects to" style={{ height: '40px' }} />
                <Avatar
                  size={52}
                   style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%',
                  }}
                 >
                    <div style={{ padding: '6px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={ZLShield} alt="ZoomLogi" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    </div>
                 </Avatar>
              </Flex>
            }
          >
            <ConnectsSensors closeModal={closeModal} id={sensor_id} sensorData={sensorData} onSuccess={handleSuccess} />
          </CustomModalWithoutButton>
        )}
      </div>
    </>
  );
};

export default Sensors;
